import ky from "ky"
import apiClient from "./ApiClient"
import { endSession } from "./Session"
import { API_URL } from "../Globals"
import IUser from "../../server/src/Interfaces/IUser"

const updateFireplaces = async (sessionToken: string | undefined, setFireplaceIds: any) => {
    try {
        const data = await apiClient.get(`${API_URL}/api/fireplace/all`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionToken,
                'Token': localStorage.getItem('token')?.toString()
            }
        }).json()
        setFireplaceIds(data)
    } catch {
        console.error('Tulisijatietojen lataus epäonnistui.')
    }
}

const updateAddressCategories = async (sessionToken: string | undefined, setAddressCategories: any) => {
    try {
        const data = await apiClient.get(`${API_URL}/api/address/category/all`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionToken,
                'Token': localStorage.getItem('token')?.toString()
            }
        }).json()
        setAddressCategories(data)
    } catch {
        console.error('Osoitekategorioiden lataus epäonnistui.')
    }
}

const updateAddressTypes = async (sessionToken: string | undefined, setAddressTypes: any) => {
    try {
        const data = await apiClient.get(`${API_URL}/api/address/type/all`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionToken,
                'Token': localStorage.getItem('token')?.toString()
            }
        }).json()
        setAddressTypes(data)
    } catch {
        console.error('Osoitetyyppien lataus epäonnistui.')
    }
}

const updateUsers = async (sessionToken: string | undefined, setUsers: any) => {
    try {
        const data = await apiClient.get(`${API_URL}/api/user/directory`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionToken,
                'Token': localStorage.getItem('token')?.toString()
            }
        }).json()
        setUsers(data)
    } catch {
        console.error('Käyttäjähakemiston lataus epäonnistui.')
    }
}

const renewToken = async (): Promise<IUser | null> => {
    try {
        const response = await ky.get(`${API_URL}/api/renewToken`, {
            headers: {
                'Content-Type': 'application/json',
                'Token': localStorage.getItem('token')?.toString()
            }
        });

        const data: IUser = await response.json();

        localStorage.setItem('sessionToken', data.sessionToken ?? '');
        localStorage.setItem('username', data.username ?? '');
        localStorage.setItem('firstName', data.firstName ?? '');
        localStorage.setItem('lastName', data.lastName ?? '');
        localStorage.setItem('sessionValid', 'true');
        localStorage.setItem('permissions', JSON.stringify(data.permissions) ?? '');
        localStorage.setItem('token', data.token ?? '');

        return data
    } catch (error: any) {
        if (error.response?.status === 401) {
            endSession();
        } else {
            console.error('Istunnon uusiminen epäonnistui.');
        }
        return null
    }
};

export { updateFireplaces, updateAddressCategories, updateAddressTypes, updateUsers, renewToken }
